<template>
  <div class="container container-fluid mt-4 mb-4">
    <account-details-card>
      <p class="text-muted small"><strong>Last login:</strong> 01/01/2020 at 10:21 am from

      <div class="row mt-2">
        <div class="col-auto">
          <c-button
            type="submit"
            variant="success"
            @click="save"
          >
            Save Changes
          </c-button>
        </div>
      </div>
    </account-details-card>

    <div v-if="false" class="card">
      <div class="card-body">
        <h2 class="card-title">Change Password</h2>

        <p class="text-muted">Please ensure that your new password meets the folowing requirements:</p>
        <ul class="no-list row">
          <li class="col-lg-6 text-muted">
            <i class="far fa-fw fa-circle"></i>
            Minimum 8 characters
          </li>
          <li class="col-lg-6 text-success">
            <i class="far fa-fw fa-check-circle"></i>
            Both passwords match
          </li>
        </ul>

        <div class="row">
          <div class="col-lg-6">
            <div class="mb-3">
              <label>New Password</label>
              <input type="text" class="form-control" />
            </div>
          </div>

          <div class="col-lg-6">
            <div class="mb-3">
              <label>Repeat New Password</label>
              <input type="text" class="form-control" />
            </div>
          </div>
        </div>

        <div class="text-right">
          <button type="button" class="btn btn-success">
            Change Password
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { toast } from '@chameleon/chameleon-vue'
import swal from 'sweetalert'
import AccountDetailsCard from '@/components/users/AccountDetailsCard'

export default {
  components: {
    AccountDetailsCard
  },

  computed: {
    ...mapState('user', ['user', 'authorized']),
  },

  methods: {

    async save () {
      // await this.updateUser(this.user)
    },
  }
}
</script>
